import React, {useState} from "react";
import {useForm} from "react-hook-form";
import MainSliderFields from "./MainSliderFields";

export default function () {
  const {register, handleSubmit, reset, control} = useForm();
  const [errors, setErrors] = useState({});
  const mainSliderFields = <MainSliderFields {...{register, errors, control}} />;

  return {
    setErrors,
    mainSliderFields,
    handleSubmit,
    reset
  }
}